import { Component } from '../base/component';
import { ensureElement } from '../../utils/utils';
import { FORM_ERRORS } from '../../utils/constants';
export class Form extends Component {
    constructor(container, events) {
        super(container);
        this.container = container;
        this.events = events;
        this._submitButton = ensureElement('button[type=submit]', this.container);
        this._errorText = ensureElement('.form__errors', this.container);
    }
    set valid(value) {
        this._submitButton.disabled = !value;
    }
    set errors(value) {
        if (value.length) {
            const errorMessages = [];
            value.forEach((item) => {
                errorMessages.push(FORM_ERRORS[item]);
                this.setText(this._errorText, errorMessages.join(', '));
            });
        }
        else {
            this.setText(this._errorText, '');
        }
    }
    onInputChange(form) {
        this.events.emit(`${form}:change`);
    }
    render(data) {
        Object.assign(this, data);
        return this.container;
    }
}
export class PaymentForm extends Form {
    constructor(container, events) {
        super(container, events);
        this._onlineButton = ensureElement('[name="card"]', this.container);
        this._offlineButton = ensureElement('[name="cash"]', this.container);
        this._address = ensureElement('[name="address"]', this.container);
        this._onlineButton.addEventListener('click', () => {
            this.events.emit('paymentFormMethod:click', {
                addClass: this._onlineButton,
                removeClass: this._offlineButton,
            });
            this._currentMethod = 'online';
            this.onInputChange('paymentForm');
        });
        this._offlineButton.addEventListener('click', () => {
            this.events.emit('paymentFormMethod:click', {
                addClass: this._offlineButton,
                removeClass: this._onlineButton,
            });
            this._currentMethod = 'offline';
            this.onInputChange('paymentForm');
        });
        this._address.addEventListener('input', () => {
            this.onInputChange('paymentForm');
        });
        this.container.addEventListener('submit', (e) => {
            e.preventDefault();
            this.events.emit('paymentForm:submit', {
                method: this.method,
                address: this.address,
            });
            this.events.emit('userForm:render');
        });
    }
    set address(value) {
        this._address.value = value;
    }
    get address() {
        return this._address.value;
    }
    set method(value) {
        this._offlineButton.classList.remove('button_alt-active');
        this._onlineButton.classList.remove('button_alt-active');
        this._currentMethod = value;
    }
    get method() {
        return this._currentMethod;
    }
    checkFormValidity() {
        return { address: Boolean(this.address), method: Boolean(this.method) };
    }
}
export class UserForm extends Form {
    constructor(container, events) {
        super(container, events);
        this._email = ensureElement('[name="email"]', this.container);
        this._phone = ensureElement('[name="phone"]', this.container);
        this._email.addEventListener('input', () => {
            this.onInputChange('userForm');
        });
        this._phone.addEventListener('input', () => {
            this.onInputChange('userForm');
        });
        this.container.addEventListener('submit', (e) => {
            e.preventDefault();
            this.events.emit('userForm:submit', {
                phone: this.phone,
                email: this.email,
            });
        });
    }
    set email(value) {
        this._email.value = value;
    }
    get email() {
        return this._email.value;
    }
    set phone(value) {
        this._phone.value = value;
    }
    get phone() {
        return this._phone.value;
    }
    checkFormValidity() {
        return { phone: Boolean(this.phone), email: Boolean(this.email) };
    }
}
